module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-italic.9b695c7d.eot";